import { v4 as uuid } from "uuid";

/**
 * Product Database can be added here.
 * You can add products of your wish with different attributes
 * */

export const products = [
  {
    _id: uuid(),
    title:
      "Canon EOS M50 Mark II Mirrorless Camera EF-M15-45mm is STM Lens  (Black)",
    categoryName: "DSLR",
    brandName: "Canon",
    image:
      "https://res.cloudinary.com/dhshzqkzm/image/upload/v1648442401/LensStore/Products/digital-camera-eos-m50-mark-ii-eos-m50-mark-ii-canon-original-imag2gzkexzqhyhu_pd8n4y.webp",
    price: {
      earlier_price: "₹58,945",
      current_price: "₹58,995",
      offer_percentage: "5",
    },
    rating: "4.5",
    isInWishlist: false,
    isInCart: false,
    isInStock: true,
    fastDelivery: true,
    isNewBadge: false,
  },
  {
    _id: uuid(),
    title: "Canon EOS 1500D DSLR Camera Body+ 18-55 mm IS II Lens  (Black)",
    categoryName: "DSLR",
    brandName: "Canon",
    image:
      "https://res.cloudinary.com/dhshzqkzm/image/upload/v1648442443/LensStore/Products/eos-1500d-canon-original-imafzfughbzn7tmg_qmohzr.webp",
    price: {
      earlier_price: "₹39,995",
      current_price: "₹36,449",
      offer_percentage: "8",
    },
    rating: "4.5",
    isInWishlist: false,
    isInCart: false,
    isInStock: true,
    fastDelivery: true,
    isNewBadge: true,
  },
  {
    _id: uuid(),
    title:
      "Canon EOS 3000D DSLR Camera 1 Camera Body, 18 - 55 mm Lens  (Black)",
    categoryName: "DSLR",
    brandName: "Canon",
    image:
      "https://res.cloudinary.com/dhshzqkzm/image/upload/v1648442483/LensStore/Products/canon-eos-eos-3000d-dslr-original-imaf3t5h9yuyc5zu_y44to7.webp",
    price: {
      earlier_price: "₹29,495",
      current_price: "₹26,949",
      offer_percentage: "8",
    },
    rating: "4.4",
    isInWishlist: false,
    isInCart: false,
    isInStock: true,
    fastDelivery: true,
    isNewBadge: false,
  },
  {
    _id: uuid(),
    title: "Canon EOS 200D II DSLR Camera EF-S18-55mm IS STM  (Black)",
    categoryName: "DSLR",
    brandName: "Canon",
    image:
      "https://res.cloudinary.com/dhshzqkzm/image/upload/v1648442514/LensStore/Products/200d-ii-200d-ii-canon-original-imaffvrhzyqzayys_jg7qmz.webp",
    price: {
      earlier_price: "₹59,995",
      current_price: "₹56,449",
      offer_percentage: "5",
    },
    rating: "4.5",
    isInWishlist: false,
    isInCart: false,
    isInStock: true,
    fastDelivery: true,
    isNewBadge: false,
  },
  {
    _id: uuid(),
    title: "Canon M6 Mark II Mirrorless Camera with 15-45 lens  (Black)",
    categoryName: "DSLR",
    brandName: "Canon",
    image:
      "https://res.cloudinary.com/dhshzqkzm/image/upload/v1648442321/LensStore/Products/eos-m6-mark-ii-canon-original-imafmvz74s9cbbh7_a8nv3b.webp",
    price: {
      earlier_price: "₹83,995",
      current_price: "₹75,949",
      offer_percentage: "9",
    },
    rating: "4.4",
    isInWishlist: false,
    isInCart: false,
    isInStock: false,
    fastDelivery: true,
    isNewBadge: false,
  },
  {
    _id: uuid(),
    title: "Canon EOS 7D Mark II DSLR Camera (Body only)  (Black)",
    categoryName: "DSLR",
    brandName: "Canon",
    image:
      "https://res.cloudinary.com/dhshzqkzm/image/upload/v1648442223/LensStore/Products/canon-eos-7d-mark-ii-body-dslr-original-imae3yryhwq7fgyx_y5za34.webp",
    price: {
      earlier_price: "₹1,24,995",
      current_price: "₹99,949",
      offer_percentage: "20",
    },
    rating: "4.1",
    isInWishlist: false,
    isInCart: false,
    isInStock: true,
    fastDelivery: true,
    isNewBadge: false,
  },
  {
    _id: uuid(),
    title: "NIKON Z5 Mirrorless Camera Z 5 Body  (Black)",
    categoryName: "DSLR",
    brandName: "Nikon",
    image:
      "https://res.cloudinary.com/dhshzqkzm/image/upload/v1648442823/LensStore/Products/z-5-body-z5-nikon-original-imag2zugujc7aeva_wmvg2x.webp",
    price: {
      earlier_price: "₹1,11,995",
      current_price: "₹95,240",
      offer_percentage: "14",
    },
    rating: "5",
    isInWishlist: false,
    isInCart: false,
    isInStock: false,
    fastDelivery: true,
    isNewBadge: false,
  },
  {
    _id: uuid(),
    title: "NIKON D780 DSLR Camera Body with 24-120 mm  (Black)",
    categoryName: "DSLR",
    brandName: "Nikon",
    image:
      "https://res.cloudinary.com/dhshzqkzm/image/upload/v1648442861/LensStore/Products/d780-d780-nikon-original-imafrexfxntwzhnz_ryrkpv.webp",
    price: {
      earlier_price: "₹1,98,995",
      current_price: "₹1,83,640",
      offer_percentage: "7",
    },
    rating: "5",
    isInWishlist: false,
    isInCart: false,
    isInStock: true,
    fastDelivery: true,
    isNewBadge: true,
  },
  {
    _id: uuid(),
    title:
      "NIKON Z7 II Body Mirrorless Camera with 64GB UHS-II SD Card  (Black)",
    categoryName: "DSLR",
    brandName: "Nikon",
    image:
      "https://res.cloudinary.com/dhshzqkzm/image/upload/v1648442783/LensStore/Products/z7-ii-z7-ii-body-nikon-original-imag4fmgtyyzer4a_op6clf.webp",
    price: {
      earlier_price: "₹2,49,995",
      current_price: "₹2,36,449",
      offer_percentage: "5",
    },
    rating: "5",
    isInWishlist: false,
    isInCart: false,
    isInStock: true,
    fastDelivery: true,
    isNewBadge: true,
  },
  {
    _id: uuid(),
    title: "SONY ILCE-7SM3/BQ IN5 Mirrorless Camera Mirrorless  (Black)",
    categoryName: "DSLR",
    brandName: "Sony",
    image:
      "https://res.cloudinary.com/dhshzqkzm/image/upload/v1648443006/LensStore/Products/alpha-7siii-ilce-7sm3-bq-in5-sony-original-imafya2qhvjjmruh_raa2xh.webp",
    price: {
      earlier_price: "₹3,34,990",
      current_price: "₹2,96,940",
      offer_percentage: "11",
    },
    rating: "4",
    isInWishlist: false,
    isInCart: false,
    isInStock: true,
    fastDelivery: true,
    isNewBadge: true,
  },
  {
    _id: uuid(),
    title:
      "SONY ILCE-7M4K/BQIN5 Mirrorless Camera Single Lens: 28-70 mm  (Black)",
    categoryName: "DSLR",
    brandName: "Sony",
    image:
      "https://res.cloudinary.com/dhshzqkzm/image/upload/v1648443006/LensStore/Products/alpha-7siii-ilce-7sm3-bq-in5-sony-original-imafya2qhvjjmruh_raa2xh.webp",
    price: {
      earlier_price: "₹2,62,490",
      current_price: "₹2,42,940",
      offer_percentage: "7",
    },
    rating: "2.7",
    isInWishlist: false,
    isInCart: false,
    isInStock: true,
    fastDelivery: true,
    isNewBadge: true,
  },
  {
    _id: uuid(),
    title:
      "Panasonic Lumix DMC-GH4 Mirrorless Camera Body with 12-60mm Lens  (Black)",
    categoryName: "DSLR",
    brandName: "Panasonic",
    image:
      "https://res.cloudinary.com/dhshzqkzm/image/upload/v1648443006/LensStore/Products/alpha-7siii-ilce-7sm3-bq-in5-sony-original-imafya2qhvjjmruh_raa2xh.webp",
    price: {
      earlier_price: "₹89,990",
      current_price: "₹73,949",
      offer_percentage: "17",
    },
    rating: "4.7",
    isInWishlist: false,
    isInCart: false,
    isInStock: true,
    fastDelivery: true,
    isNewBadge: true,
  },
  {
    _id: uuid(),
    title:
      "Panasonic G Series DC-G95MGW-K Mirrorless Camera Body with Single Lens: 12-60mm lens  (Black)",
    categoryName: "DSLR",
    brandName: "Panasonic",
    image:
      "https://res.cloudinary.com/dhshzqkzm/image/upload/v1648443458/LensStore/Products/dc-g95mgw-k-dc-g95mgw-k-panasonic-original-imafgu2jvfgvqyyy_jwcugg.webp",
    price: {
      earlier_price: "₹94,990",
      current_price: "₹90,139",
      offer_percentage: "5",
    },
    rating: "4",
    isInWishlist: false,
    isInCart: false,
    isInStock: true,
    fastDelivery: true,
    isNewBadge: true,
  },
  {
    _id: uuid(),
    title:
      "Canon EF-S 10 - 18 mm f/4.5 - 5.6 IS STM Lens  (Black, 16 - 300 mm)",
    categoryName: "Lens",
    brandName: "Canon",
    image:
      "https://res.cloudinary.com/dhshzqkzm/image/upload/v1648443772/LensStore/Products/canon-ef-s-original-imae3fpcz4qgnzzu_mut0oz.webp",
    price: {
      earlier_price: "₹20,995",
      current_price: "₹19,945",
      offer_percentage: "5",
    },
    rating: "3.6",
    isInWishlist: false,
    isInCart: false,
    isInStock: true,
    fastDelivery: true,
    isNewBadge: true,
  },
  {
    _id: uuid(),
    title: "Canon EF 50 mm f/1.8 STM Lens  (Black, 50 mm)",
    categoryName: "Lens",
    brandName: "Canon",
    image:
      "https://res.cloudinary.com/dhshzqkzm/image/upload/v1648443872/LensStore/Products/canon-ef-50-mm-f-1-8-stm-original-imafeupuadrnzmyy_vgze1m.webp",
    price: {
      earlier_price: "₹8,995",
      current_price: "₹8,945",
      offer_percentage: "1",
    },
    rating: "4.6",
    isInWishlist: false,
    isInCart: false,
    isInStock: false,
    fastDelivery: true,
    isNewBadge: true,
  },
  {
    _id: uuid(),
    title:
      "NIKON AF-S DX NIKKOR 18-140mm f/3.5-5.6 G ED VR Lens  (Black, 70 - 200 mm)",
    categoryName: "Lens",
    brandName: "Nikon",
    image:
      "https://res.cloudinary.com/dhshzqkzm/image/upload/v1648444050/LensStore/Products/nikon-af-s-dx-nikkor-18-140-f-3-5-5-6-g-ed-vr-af-s-dx-nikkor-18-original-imaez9rvz7e6cxs6_begzdb.webp",
    price: {
      earlier_price: "₹27,450",
      current_price: "₹26,949",
      offer_percentage: "1",
    },
    rating: "1.3",
    isInWishlist: false,
    isInCart: false,
    isInStock: true,
    fastDelivery: true,
    isNewBadge: true,
  },
  {
    _id: uuid(),
    title: "NIKON AF-S DX Micro NIKKOR 40mm f/2.8G Lens  (Black)",
    categoryName: "Lens",
    brandName: "Nikon",
    image:
      "https://res.cloudinary.com/dhshzqkzm/image/upload/v1648444014/LensStore/Products/nikon-micro-af-s-dx-micro-nikkor-40mm-f-2-8g-original-imad23vgycfpgarz_ejazqb.webp",
    price: {
      earlier_price: "₹19,450",
      current_price: "₹18,189",
      offer_percentage: "6",
    },
    rating: "2.7",
    isInWishlist: false,
    isInCart: false,
    isInStock: true,
    fastDelivery: true,
    isNewBadge: false,
  },
  {
    _id: uuid(),
    title: "Photron PHOC500 Tripod  (Black, Supports Up to 1000 g)",
    categoryName: "Tripods",
    brandName: "Photron",
    image:
      "https://res.cloudinary.com/dhshzqkzm/image/upload/v1648444831/LensStore/Products/phoc500-photron-original-imag7ach4n255f2d_gcamtb.webp",
    price: {
      earlier_price: "₹990",
      current_price: "₹439",
      offer_percentage: "55",
    },
    rating: "4.2",
    isInWishlist: false,
    isInCart: false,
    isInStock: true,
    fastDelivery: true,
    isNewBadge: true,
  },
  {
    _id: uuid(),
    title: "Photron PHOC500 Tripod  (Black, Supports Up to 1000 g)",
    categoryName: "Tripods",
    brandName: "Photron",
    image:
      "https://res.cloudinary.com/dhshzqkzm/image/upload/v1648444831/LensStore/Products/phoc500-photron-original-imag7ach4n255f2d_gcamtb.webp",
    price: {
      earlier_price: "₹990",
      current_price: "₹439",
      offer_percentage: "55",
    },
    rating: "3.2",
    isInWishlist: false,
    isInCart: false,
    isInStock: true,
    fastDelivery: true,
    isNewBadge: false,
  },
  {
    _id: uuid(),
    title: "DIGITEK DTR 550 LW Tripod  (Black, Supports Up to 5000 g)",
    categoryName: "Tripods",
    brandName: "DIGITEK",
    image:
      "https://res.cloudinary.com/dhshzqkzm/image/upload/v1648444831/LensStore/Products/phoc500-photron-original-imag7ach4n255f2d_gcamtb.webp",
    price: {
      earlier_price: "₹2,495",
      current_price: "₹1,449",
      offer_percentage: "41",
    },
    rating: "4.4",
    isInWishlist: false,
    isInCart: false,
    isInStock: true,
    fastDelivery: true,
    isNewBadge: false,
  },
  {
    _id: uuid(),
    title: "DIGITEK DTR 550 LW Tripod  (Black, Supports Up to 5000 g)",
    categoryName: "Tripods",
    brandName: "DIGITEK",
    image:
      "https://res.cloudinary.com/dhshzqkzm/image/upload/v1648444972/LensStore/Products/digitek-dtr-550-lw-original-imafwtrbagrpqg3c_aqi2fo.webp",
    price: {
      earlier_price: "₹2,495",
      current_price: "₹1,449",
      offer_percentage: "41",
    },
    rating: "4.4",
    isInWishlist: false,
    isInCart: false,
    isInStock: false,
    fastDelivery: true,
    isNewBadge: false,
  },
  {
    _id: uuid(),
    title:
      "DIGITEK Platinum (178 cm)Aluminum Light Weight Tripod DPTR 890 VD Tripod",
    categoryName: "Tripods",
    brandName: "DIGITEK",
    image:
      "https://res.cloudinary.com/dhshzqkzm/image/upload/v1648445072/LensStore/Products/platinum-178-cm-aluminum-light-weight-tripod-dptr-890-vd-digitek-original-imag7we8x43n2bxb_ixg0rg.webp",
    price: {
      earlier_price: "₹4,995",
      current_price: "₹4,778",
      offer_percentage: "4",
    },
    rating: "4.4",
    isInWishlist: false,
    isInCart: false,
    isInStock: true,
    fastDelivery: true,
    isNewBadge: true,
  },
];
